import { render, staticRenderFns } from "./FeedSelect.vue?vue&type=template&id=2d60b5a5&"
import script from "./FeedSelect.vue?vue&type=script&lang=js&"
export * from "./FeedSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports